import React, { useState, useEffect } from 'react';
import * as EmailValidator from 'email-validator';
import InviteJSX from './Invite.jsx';
import { createSurveyInvitation } from '../../api';

const Invite = () => {
  const [selectValue, setSelectValue] = useState('accepted');
  const [emailValue, setEmailValue] = useState('');
  const [emailInvalid, setEmailInvalid] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState('');
  const [languageOptions, setLanguageOptions] = useState('en');
  const [languageInvalid, setLanguageInvalid] = useState(false);
  const [serviceTypeInvalid, setServiceTypeInvalid] = useState(false);

  const handleInviteSubmission = async (event) => {
    event.preventDefault();

    setEmailInvalid(false);
    setLanguageInvalid(false);
    setServiceTypeInvalid(false);

    // Validation checks
    let isValid = true;

    // Service Type validation - always required
    if (!selectedOptions) {
      setServiceTypeInvalid(true);
      isValid = false;
    }

    // Language validation - always required
    if (!languageOptions) {
      setLanguageInvalid(true);
      isValid = false;
    }

    // Email validation for accepted status
    if (selectValue === 'accepted') {
      const emailValid = EmailValidator.validate(emailValue);
      if (!emailValid) {
        setEmailInvalid(true);
        isValid = false;
      }
    }

    // Return early if validation fails
    if (!isValid) {
      return;
    }

    const postData = {
      response: selectValue,
      email: selectValue === 'accepted' ? emailValue : undefined,
      service_type: selectedOptions,
      language: languageOptions,
    };

    try {
      const response = await createSurveyInvitation(postData);
      if (response.data && response.data.success) {
        setSelectValue('accepted');
        setEmailInvalid(false);
        setLanguageInvalid(false);
        setServiceTypeInvalid(false);
        setEmailValue('');
        setSelectedOptions('');
        setLanguageOptions('en'); // Reset to English
        setSuccessModalOpen(true);
      }
    } catch (error) {
      console.error("Error creating survey invitation:", error);
    }
  };

  const handleSelectChange = (event) => {
    if (event.target.value === 'declined') {
      setEmailInvalid(false);
    }
    setSelectValue(event.target.value);
  }

  const handleEmailChange = (event) => {
    setEmailValue(event.target.value);
    if (EmailValidator.validate(event.target.value)) {
      setEmailInvalid(false);
    }
  }

  const handleModalClose = () => {
    setSuccessModalOpen(false)
  }

  const handleSelectOptions = (event) => {
    setSelectedOptions(event.target.value);
    if (event.target.value) {
      setServiceTypeInvalid(false);
    }
  }

  const handleLanguageOptions = (event) => {
    setLanguageOptions(event.target.value);
    if (event.target.value) {
      setLanguageInvalid(false);
    }
  };

  return (
      <InviteJSX
          handleInviteSubmission={handleInviteSubmission}
          handleSelectChange={handleSelectChange}
          selectValue={selectValue}
          emailValue={emailValue}
          handleEmailChange={handleEmailChange}
          emailInvalid={emailInvalid}
          successModalOpen={successModalOpen}
          handleModalClose={handleModalClose}
          selectedOptions={selectedOptions}
          handleSelectOptions={handleSelectOptions}
          handleLanguageOptions={handleLanguageOptions}
          languageOptions={languageOptions}
          languageInvalid={languageInvalid}
          serviceTypeInvalid={serviceTypeInvalid}
      />
  );
}

export default Invite